// extracted by mini-css-extract-plugin
export default {"galleryContainer":"customGallery_galleryContainer__c14-S","thumbnailButton":"customGallery_thumbnailButton__MZFdT"};